import { createContext } from 'react';
export const MapSearchContext = createContext({
    resultFilters: {},
    setResultFilters: () => {},
    toggleDisplayEssentialsOnly: () => {},
});
